function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M 27.482 3.257 L 17.537 10.718 L 18.632 6.582 L 27.482 3.257 Z",
  fill: "#E2761B"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M 4.517 3.257 L 14.377 10.789 L 13.802 6.742 L 4.517 3.257 Z",
  fill: "#E4761B"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M23.8978 20.5697L21.2485 24.6652L26.9154 26.2403L28.5446 20.6556L23.8978 20.5697Z",
  fill: "#E4761B"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M3.45459 20.6556L5.08381 26.2403L10.7507 24.6652L8.10141 20.5697L3.45459 20.6556Z",
  fill: "#E4761B"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M21.2487 24.6651L17.8628 23.004L18.132 25.2379L18.1036 26.183L21.2487 24.6651Z",
  fill: "#D7C1B3"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M10.751 24.6651L13.8961 26.183L13.8819 25.2379L14.1228 23.004L10.751 24.6651Z",
  fill: "#D7C1B3"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M13.9526 19.2237L11.1333 18.3789L13.1167 17.4624L13.9526 19.2237Z",
  fill: "#233447"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M18.0327 19.2237L18.8686 17.4624L20.8661 18.3789L18.0327 19.2237Z",
  fill: "#233447"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M10.7508 24.6652L11.2325 20.5697L8.10156 20.6556L10.7508 24.6652Z",
  fill: "#CD6116"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M20.7671 20.5697L21.2488 24.6652L23.898 20.6556L20.7671 20.5697Z",
  fill: "#CD6116"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M23.1468 16.0447L17.5366 16.3024L18.0466 19.2237L18.8825 17.4623L20.8801 18.3788L23.1468 16.0447Z",
  fill: "#CD6116"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M11.1334 18.3788L13.131 17.4623L13.9527 19.2237L14.4769 16.3024L8.85254 16.0447L11.1334 18.3788Z",
  fill: "#CD6116"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M18.0467 19.2237L17.3809 22.6747L17.8625 23.0041L20.781 20.6986L20.8801 18.3788L18.0467 19.2237Z",
  fill: "#F6851B"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M11.1333 18.3788L11.2041 20.6986L14.1226 23.0041L14.6042 22.6747L13.9526 19.2237L11.1333 18.3788Z",
  fill: "#F6851B"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M18.1037 26.1832L18.132 25.2381L17.877 25.009H14.1086L13.8819 25.2381L13.8961 26.1832L10.751 24.6653L11.856 25.5818L14.0803 27.1426H17.9054L20.1438 25.5818L21.2488 24.6653L18.1037 26.1832Z",
  fill: "#C0AD9E"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M17.8628 23.004L17.3811 22.6747H14.6044L14.1227 23.004L13.8818 25.2379L14.1085 25.0088H17.877L18.132 25.2379L17.8628 23.004Z",
  fill: "#161616"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M27.8931 11.2046L28.7573 7.08047L27.4823 3.25708L17.8628 10.4743L21.5604 13.6389L26.7881 15.1855L27.9498 13.8108L27.4539 13.4528L28.2473 12.7082L27.6381 12.2213L28.4315 11.6055L27.8931 11.2046Z",
  fill: "#763D16"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M3.25635 7.08047L4.10638 11.2046L3.55386 11.6055L4.36138 12.2213L3.7522 12.7082L4.54556 13.4528L4.04971 13.8108L5.19724 15.1855L10.4249 13.6389L14.1225 10.4743L4.51722 3.25708L3.25635 7.08047Z",
  fill: "#763D16"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M26.7881 15.1855L21.5604 13.6389L23.1472 16.0446L20.7812 20.6986L23.898 20.6556H28.5448L26.7881 15.1855Z",
  fill: "#F6851B"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M10.4248 13.6389L5.19715 15.1855L3.45459 20.6556H8.10141L11.204 20.6986L8.85227 16.0446L10.4248 13.6389Z",
  fill: "#F6851B"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M17.5366 16.3025L17.8624 10.4743L19.3783 6.30725H12.6348L14.1223 10.4743L14.4765 16.3025L14.604 18.1354V22.6748H17.3808L17.3949 18.1354L17.5366 16.3025Z",
  fill: "#F6851B"
});

var _ref23 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  x: 3.19971,
  y: 3.19983,
  width: 25.6,
  height: 24,
  fill: "white"
})));

var SvgMetamask = (_ref) => {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    style: {},
    transform: "matrix(1.215071, 0, 0, 1.215071, -3.449428, -2.468884)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9.694,
    y: 20.207,
    width: 12.552,
    height: 4.43,
    style: {
      fill: "rgb(228, 118, 27)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.763,
    y: 16.271,
    width: 4.408,
    height: 6.381,
    style: {
      fill: "rgb(228, 117, 31)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.603,
    y: 10.458,
    width: 14.715,
    height: 5.985,
    style: {
      fill: "rgb(228, 118, 27)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.421,
    y: 15.477,
    width: 15.109,
    height: 5.651,
    style: {
      fill: "rgb(228, 117, 31)"
    }
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22), _ref23);
};

var ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMetamask, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/metamask.4bf59110.svg";
export { ForwardRef as ReactComponent };